import React, { useMemo, useRef, useEffect, useState } from "react";
import styles from "./styles.module.css";
import backgroundImage from "../images/OneDayDragonTiger/tableBg.webp";
import newRoundImg from "../images/OneDayDragonTiger/New_Round.svg";
import welcome from "../images/OneDayDragonTiger/welcome.gif";
import ideal from "../images/OneDayDragonTiger/idle.gif";
import clapping from "../images/OneDayDragonTiger/clapping.gif";
import crown from "../images/OneDayDragonTiger/crown.png";
import closedCard from "../images/OneDayDragonTiger/closed-card.jpg";
import { cards } from "../images/index";
import useRoundLoader from "../../../api/useRoundLoader";
import useGameScreenLoader from "../../../api/useGameScreenLoader";
import GameAreaLoader from "../../Loader/GameAreaLoader";

export default function GameScreen({ bettingClosed, animationTime, socketData, settledData, remainingTime }) {

  const prevDragonCard = useRef(null);
  const prevTigerCard = useRef(null);
  const prevWinner = useRef(null);

  const roundId = socketData?.roundId;
  const phase = socketData?.phase; // "PHASE1" | "PHASE2" | "IDLE" | "WINNER"

const settlement = socketData?.settlement;

const { gameScreenLoader, processingLoader } = useGameScreenLoader(roundId, !!settlement, 5000);

  const getWinner = (outcome) => {
    if (!outcome) return null;
    if (outcome.includes("TIGER") && !outcome.includes("DRAGON")) return "Tiger";
    if (outcome.includes("DRAGON") && !outcome.includes("TIGER")) return "Dragon";
    const first = outcome.split(",")[0];
    if (first === "TIGER") return "Tiger";
    if (first === "DRAGON") return "Dragon";
    return "Tie";
  };

  // Settlement store karo (fallback ke liye)
  useEffect(() => {
    if (settledData?.dragonCard) {
      prevDragonCard.current = settledData.dragonCard;
    }
    if (settledData?.tigerCard) {
      prevTigerCard.current = settledData.tigerCard;
    }
    if (settledData?.winner) {
      prevWinner.current = settledData.winner;
    }
  }, [settledData]);

  // Naya round shuru hote hi refs clear karo
  useEffect(() => {
    if (phase === "PHASE1") {
      prevDragonCard.current = null;
      prevTigerCard.current = null;
      prevWinner.current = null;
    }
  }, [phase, roundId]);

  const mapCardStringToAsset = (cardString) => {
    if (!cardString || typeof cardString !== "string") return closedCard;
    const raw = cardString.trim().toUpperCase().replace(/\.(WEBP|PNG|JPE?G|SVG)$/i, "");
    if (cards[raw]) return cards[raw];
    if (cards[`${raw}.webp`]) return cards[`${raw}.webp`];
    return closedCard;
  };

  // ─── GIF ───
  const currentGif = useMemo(() => {
    if (phase === "PHASE1") return welcome;
    if (phase === "PHASE2") return ideal;
    if (phase === "IDLE") return ideal;
    if (phase === "WINNER") {
      const t = settledData?.resultTime ?? settledData?.winnerTime;
      if (t !== undefined && t <= 5) return clapping;
      return ideal;
    }
    return ideal;
  }, [phase, settledData]);

  // ─── DRAGON CARD ───
  const dragonCardSrc = useMemo(() => {
    if (phase === "PHASE1") return closedCard;
    if (phase === "PHASE2" || phase === "IDLE" || phase === "WINNER") {
      const card = settledData?.dragonCard ?? prevDragonCard.current;
      return mapCardStringToAsset(card);
    }
    return closedCard;
  }, [phase, settledData]);

  // ─── TIGER CARD ───
  const tigerCardSrc = useMemo(() => {
    if (phase === "PHASE1" || phase === "PHASE2") return closedCard;
    if (phase === "IDLE" || phase === "WINNER") {
      const card = settledData?.tigerCard ?? prevTigerCard.current;
      return mapCardStringToAsset(card);
    }
    return closedCard;
  }, [phase, settledData]);

  // ─── WINNER ───
  const winner = getWinner(settledData?.outcome);
  const showWinner = phase === "WINNER" && !!winner;

  // ─── NEW ROUND BANNER ───
  const showNewRound = phase === "PHASE1";

  return (
    <GameAreaLoader showLoader={gameScreenLoader}>
      <div className={styles.gameContainer}>
        <div className={styles.mainGameArea}>
          <div className={styles.videoArea}>
            <div className={styles.videoContainer}>

              {/* Background */}
              <img
                src={backgroundImage}
                alt="1 Day Dragon Tiger"
                className={styles.backgroundImage}
                draggable={false}
              />

              {/* GIF overlay */}
              <div className={styles.gifOverlay}>
                <img
                  src={currentGif}
                  alt="stage gif"
                  className={styles.gifImage}
                  draggable={false}
                  style={{ objectFit: "contain" }}
                />
              </div>

              {/* Cards + Winner */}
              <div className={styles.cardsContainer}>

                {/* Dragon Card */}
                <div className={styles.dragonCard}>
                  <img
                    src={dragonCardSrc}
                    alt="Dragon Card"
                    className={styles.cardImage}
                    draggable={false}
                  />
                  <span className={styles.cardLabel}>Dragon</span>
                </div>

                {/* Tiger Card */}
                <div className={styles.tigerCard}>
                  <img
                    src={tigerCardSrc}
                    alt="Tiger Card"
                    className={styles.cardImage}
                    draggable={false}
                  />
                  <span className={styles.cardLabel}>Tiger</span>
                </div>

                {showWinner && (
                  <div className={styles.winnerAnimation}>
                    <img src={crown} alt="Winner Crown" className={styles.crownImage} />
                    <span className={styles.winnerText}>
                      Winner: {winner}
                    </span>
                  </div>
                )}

              </div>

            </div>
          </div>
        </div>
        {processingLoader  && (
      <div className={styles.dataProcessingOverlay}>
        <div className={styles.cardSpinner} />
      </div>
    )}
      </div>
    </GameAreaLoader>
  );
}